import { useState, useEffect, useRef } from 'react';
import { Icon } from '../Icon/Icon';

interface SearchBarProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

export function SearchBar({ value, onChange, placeholder }: SearchBarProps) {
  const [local, setLocal] = useState(value);
  const timerRef = useRef<ReturnType<typeof setTimeout>>();

  useEffect(() => {
    setLocal(value);
  }, [value]);

  useEffect(() => {
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, []);

  const handleChange = (v: string) => {
    setLocal(v);
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => onChange(v), 400);
  };

  return (
    <div className="search-bar">
      <span className="search-bar__icon">
        <Icon name="search" size={20} />
      </span>
      <input
        className="search-bar__input"
        type="text"
        value={local}
        onChange={(e) => handleChange(e.target.value)}
        placeholder={placeholder}
      />
      {local && (
        <button
          className="search-bar__clear"
          onClick={() => {
            setLocal('');
            onChange('');
          }}
          aria-label="Clear"
        >
          <Icon name="x" size={16} />
        </button>
      )}
    </div>
  );
}
